export const ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST = 'ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST';
export const ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS = 'ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS';
export const ACTION_LOAD_SITE_FOOTER_LINKS__FAIL = 'ACTION_LOAD_SITE_FOOTER_LINKS__FAIL';

// Categories
export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST';
export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS';
export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL';

export const ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST = 'ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__REQUEST';
export const ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS = 'ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__SUCCESS';
export const ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL = 'ACTION_CREATE_SITE_FOOTER_LINK_CATEGORY__FAIL';

export const ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST = 'ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST';
export const ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS = 'ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS';
export const ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL = 'ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL';


export const ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST = 'ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST';
export const ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS = 'ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS';
export const ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL = 'ACTION_SET_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL';

export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__REQUEST';
export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__SUCCESS';
export const ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL = 'ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY_TRANSLATION__FAIL';

// Footer links
export const ACTION_CREATE_SITE_FOOTER_LINK__REQUEST = 'ACTION_CREATE_SITE_FOOTER_LINK__REQUEST';
export const ACTION_CREATE_SITE_FOOTER_LINK__SUCCESS = 'ACTION_CREATE_SITE_FOOTER_LINK__SUCCESS';
export const ACTION_CREATE_SITE_FOOTER_LINK__FAIL = 'ACTION_CREATE_SITE_FOOTER_LINK__FAIL';

export const ACTION_EDIT_SITE_FOOTER_LINK__REQUEST = 'ACTION_EDIT_SITE_FOOTER_LINK__REQUEST';
export const ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS = 'ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS';
export const ACTION_EDIT_SITE_FOOTER_LINK__FAIL = 'ACTION_EDIT_SITE_FOOTER_LINK__FAIL';

export const ACTION_DELETE_SITE_FOOTER_LINK__REQUEST = 'ACTION_DELETE_SITE_FOOTER_LINK__REQUEST';
export const ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS = 'ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS';
export const ACTION_DELETE_SITE_FOOTER_LINK__FAIL = 'ACTION_DELETE_SITE_FOOTER_LINK__FAIL';


export const ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST = 'ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST';
export const ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS = 'ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS';
export const ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL = 'ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL';

export const ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST = 'ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST';
export const ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS = 'ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS';
export const ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL = 'ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL';

export const ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__REQUEST = 'ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__REQUEST';
export const ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__SUCCESS = 'ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__SUCCESS';
export const ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__FAIL = 'ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__FAIL';

export const ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__REQUEST = 'ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__REQUEST';
export const ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__SUCCESS = 'ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__SUCCESS';
export const ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__FAIL = 'ACTION_SET_SITE_FOOTER_LINK_TRANSLATION_AVAILABILITY__FAIL';

export const ACTION_ADD_CATEGORIES = 'ACTION_ADD_CATEGORIES';
export const ACTION_ADD_LINKS = 'ACTION_ADD_LINKS';
export const ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP = 'ACTION_ADD_TEMPLATE_TO_CATEGORIES_MAP';
export const ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED = 'ACTION_SET_IS_SITE_LINK_CATEGORIES_MAX_NUMBER_REACHED';
export const ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED = 'ACTION_SET_IS_SITE_LINK_MAX_NUMBER_REACHED';
export const ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS = 'ACTION_ADD_DEFAULT_SITE_FOOTER_LINK_CATEGORY_TRANSLATIONS';
